module.exports = __webpack_public_path__ + "static/media/rounded3.5adaea51.png";